import { ReactChild } from 'react';

export namespace SectionContentTitleTypes {
  export interface ISectionTitle {
    RenderAs?: TSectionRenderAs;
    children: ReactChild | ReactChild[];
  }
  export type TSectionRenderAs = 'h4' | 'h5';
}
